import Rootview from "../core/modulos/root/view/root";

export function RootRouter(){
    return (
        <Rootview/>
    )
}